export function sortAlphaNumeric(items, sortField, sortReverse) {
  if (!items || items.length <= 1) return items

  let itemsToBeSorted = items.slice()
  itemsToBeSorted.sort((a, b) => {
    const left = a[sortField]
    const right = b[sortField]

    // Sorts strings using locale compare - i.e. "20" comes before "100"
    if (typeof left === 'string') {
      return left.localeCompare(right, undefined, {
        numeric: true
      })
    } else {
      return left - right
    }
  })
  return sortReverse ? itemsToBeSorted.reverse() : itemsToBeSorted
}
